<template>
    <div class="footer">
        <!-- <div>
            <a><router-link to="/product">关于我们</router-link></a> |
            <a><router-link to="/media">媒体报导</router-link></a> |
            <a><router-link to="/terms">服务条款</router-link></a> |
            <a><router-link to="/help">帮助中心</router-link></a> |
            <a><router-link to="/video">视频教程</router-link></a> |
            <a><router-link to="/contact">联系我们</router-link></a>
        </div> -->
        <div>
            <a href="https://beian.miit.gov.cn/" target="_blank">© 极书 版权所有 皖ICP备15004387号-3</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "footerSite"
}
</script>

<style lang="scss" scoped>
    .footer{
        height: 50px!important;
        background: #312d2a;
        text-align: center;
        color:#fff;
        line-height: 50px;
    }

    .footer > div > a  {
        height: 120px!important;
        background: #312d2a;
        text-align: center;
        color:#fff;
        line-height: 45px;
    }
    .footer > div > a >a {
        height: 120px!important;
        background: #312d2a;
        text-align: center;
        color:#fff;
        line-height: 45px;
    }
</style>



// WEBPACK FOOTER //
// src/components/footerSite.vue